module.exports = __webpack_public_path__ + "static/media/435.01b0beef.webp";